import { createSelector } from '@reduxjs/toolkit';
import { ProjectParametersState } from 'ducks/project-parameters/slices';
import { RootState } from 'store';

const projectParametersSlice = (state: RootState) => state.project_parameters;

export const selectProjectParameters = createSelector(
  [projectParametersSlice],
  (state): ProjectParametersState['project_parameters'] => state.project_parameters,
);
